import React, { useState } from 'react';

interface ServiceIconProps {
  src: string;
  alt: string;
  title: string;
}

const ServiceIcon: React.FC<ServiceIconProps> = ({ src, alt, title }) => {
  const [imageError, setImageError] = useState(false);
  const [imageLoaded, setImageLoaded] = useState(false);

  const handleImageError = () => {
    console.warn(`Erro ao carregar imagem: ${src}`);
    setImageError(true);
  };

  const handleImageLoad = () => {
    setImageLoaded(true);
  };

  // Ícone de fallback baseado no título do serviço
  const getFallbackIcon = (serviceTitle: string) => {
    const iconMap: { [key: string]: string } = {
      'Apps': '📱',
      'Web apps': '💻',
      'Web page': '🌐',
      'Sistemas': '⚙️',
      'UX/UI': '🎨',
      'Consultoria': '💡'
    };
    return iconMap[serviceTitle] || '🔧';
  };

  if (imageError) {
    return (
      <div className="w-12 h-12 bg-gradient-to-br from-primary-200 to-blue-200 rounded-xl 
                      flex items-center justify-center text-2xl shadow-md">
        {getFallbackIcon(title)}
      </div>
    );
  }

  return (
    <>
      {!imageLoaded && (
        <div className="w-12 h-12 bg-gray-200 rounded-xl animate-pulse"></div>
      )}
      <img
        src={src}
        alt={alt}
        className={`w-12 h-12 object-contain filter group-hover:brightness-110 transition-all duration-300 ${
          imageLoaded ? 'opacity-100' : 'opacity-0 absolute'
        }`}
        onError={handleImageError}
        onLoad={handleImageLoad}
      />
    </>
  );
};

export default ServiceIcon;
